import { generateURL } from 'utils/helpers';
import { apiSlice } from '.';

apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    nextDepartures: builder.query({
      query: (args) => generateURL('/service/next_departures', args),
      providesTags: ['nextdepartures'],
      keepUnusedDataFor: 3600,
    }),

    dailyTimetable: builder.query({
      query: (args) => generateURL('/service/daily_timetable', args),
      providesTags: ['daily_timetable'],
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const { useNextDeparturesQuery, useDailyTimetableQuery } = apiSlice;
